@switch (specificTemplateName) {
  @case (certificateTableNamesEnum.Overview) {
    <app-certificate-template
      [columnName]="columnName"
      [element]="element"
    ></app-certificate-template>
  }
  @case (certificateTableNamesEnum.Log) {
    <app-generic-log-template
      [columnName]="columnName"
      [element]="element"
    ></app-generic-log-template>
  }
}
